import { __module as arrayWithHoles } from '../../../../_virtual/arrayWithHoles.js';

(function (module) {
	function _arrayWithHoles(r) {
	  if (Array.isArray(r)) return r;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (arrayWithHoles));
//# sourceMappingURL=arrayWithHoles.js.map
